let certificationsList=[
    {
        title:"Java Fundamentals",
        instructor:"quarz",
        link:"https://drive.google.com/file/d/1Wi5VRAiGYnYdy3qXfxhsbuyuGeAluBkK/view?usp=drive_link",
        platform:'Youtube'
    },
    {
        title:"React Js",
        instructor:"Knowledge gate",
        link:"https://drive.google.com/file/d/1mZvQnRQjekcNw4WK2Fzu83bFtNZgbhwW/view?usp=drive_link",
        platform:'Youtube'
    },
    {
        title:"C++",
        instructor:"Abdul Bari",
        link:"https://drive.google.com/file/d/1IYLjOI4jaeAgpj0ATn6GiPTOx7LoZkDu/view?usp=drive_link",
        platform:'udemy'
    },
    {
        title:" JAVA Spring Boot",
        instructor:"in28Minutes Official",
        link:"https://drive.google.com/file/d/1xQrfJ5mKns6Avr0LbYR2gbEPKFEpwU8a/view?usp=drive_link",
        platform:'udemy'
    },
    {
        title:" JAVA Script",
        instructor:"Knowledge gate",
        link:"https://drive.google.com/file/d/1GAFFDD0xp4fxDW9eBgnf7rar8Kxozr_f/view?usp=drive_link",
        platform:'Youtube'
    },
];

const CertificatesData={certificationsList};
export default CertificatesData;